import { useQuery } from '@tanstack/react-query';
import { ALL_ACTIVE_CASES_KEY } from '../../utils/constants/queryKeys';
import { getAllActiveCasesList } from '../services/ims-api/Cases';

export const useGetAllActiveCases = (includeAidi?: boolean, includeIsNew?: boolean) => {
  return useQuery({
    queryKey: [ALL_ACTIVE_CASES_KEY, includeAidi ?? false, includeIsNew ?? false],
    queryFn: () => getAllActiveCasesList(includeAidi, includeIsNew),
    retry: false,
  });
};
